/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const AutoTestStepValidationExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['stepIdx', codecNumber, 'step_idx']]), BaseError);
export class AutoTestStepValidationException extends BaseError {
    static decode(input) {
        return AutoTestStepValidationExceptionParser.decode(input).map(res => new AutoTestStepValidationException(res));
    }
    static unsafeDecode(input) {
        return AutoTestStepValidationException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestStepValidationExceptionParser.encode(data);
    }
    static schema() {
        return AutoTestStepValidationExceptionParser.schema();
    }
}
